import * as React from 'react';
import LaneScrollContext from './LaneScrollContext';

const {
    useRef,
    useState,
} = React;

export default function ScrollableLane(props) {
     // we have a custom fixed height card of 205 which makes this much easier
    const cardHeight = 130;
    // scrollIndex holds the minimum index and maximum index that will be rendered
    // from the list of tasks in the column we use window.innerHeight as a safe option
    // to get a starting value for max
    const [ scrollIndex, setScrollIndex ] = useState({
        min: 0,
        max: Math.ceil(window.innerHeight / cardHeight ) + 2
    });
    const scrollerRef = useRef(null);
    // really hacky bit here - reaching in to the child that holds the list of children and using it to get the number of tasks in the column
    const cardCount = props.children[0].props.children.length;

    return (
        <LaneScrollContext.Provider value={ scrollIndex }>
            <div
                onScroll={ e => {
                    setScrollIndex((prev) => {
                        // we're using the async version of hook setting here
                        // because react synthetic event objects are reused e.target may be null here
                        if(!e.target) {
                            return prev;
                        }

                        const scrollableLaneHeightInCards = Math.ceil((scrollerRef.current?.getBoundingClientRect?.()?.height ?? window.innerHeight) / 205);
                        const nextBaseIndex = Math.floor(e.target.scrollTop / cardHeight);
                        const nextMinIndex = Math.min(Math.max(cardCount - scrollableLaneHeightInCards- 2, 0), Math.max(nextBaseIndex - 2, 0));
                        const nextMaxIndex = nextBaseIndex + scrollableLaneHeightInCards+ 2;

                        if(nextMinIndex === prev.min && nextMaxIndex === prev.max) {
                            return prev;
                        }

                        return {
                            min: nextMinIndex,
                            max: nextMaxIndex,
                        };
                    });
                }}
                ref={ scrollerRef }
                className='lane-container-scroll'
            >
                {
                    React.Children.map(props.children, child => {
                        if(child){
                            const marginTop = scrollIndex.min * cardHeight;
                            return React.cloneElement(child, {
                                // because we are only rendering a subset of our tasks we need to force the scrolling div 
                                // to have the correct height and use a suitable marginTop so that any tasks from  0 to scrollIndex.min
                                // appear to still be there by pushing the rendered cards down to the correct location... hacky :(
                                style: {
                                    minHeight: `${ (child.props.children.length * cardHeight) - marginTop }px`,
                                    marginTop: `${ marginTop }px`
                                },
                            });
                        }
                        return null;
                    })
                }
            </div>
        </LaneScrollContext.Provider>
    );
}